module.exports = "/_next/static/images/19-1-701a9b023c4d11256061fb1e957e94b2.svg";